import React from 'react'
import Box from '@mui/material/Box';
import CCORichText from '../../fundamentals/CCORichText/CCORichText';
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";
import CCOHeadline from '../../fundamentals/CCOHeadline';
import CCOPicture from '../../fundamentals/CCOPicture';
import CCOLinkButton from '../../fundamentals/CCOLinkButton';
import CCOOverlay from '../../fundamentals/CCOOverlay';
import PreviewElementBoxDrawer from "../../preview/PreviewElementBoxDrawer";
import { getLengthLimit } from "../../../utility/lengthLimits";
import { usePreviewLimitCheck } from "../../preview/usePreviewLimitCheck";

interface Props {
    id: string,
    breakpoints: any,
    details: RichTextElement,
    isPreview?: boolean,
    linkText?: string,
    picture: any,
    subtitle: string | null | undefined,
    targets: Array<any>,
    title: string | null | undefined
}

function C061OverlayContact({breakpoints, details, isPreview, linkText, picture, subtitle, targets, title, id}: Props) {
    const titleLimit = getLengthLimit('C061OverlayContact.title');
    const subtitleLimit = getLengthLimit('C061OverlayContact.subtitle');

    usePreviewLimitCheck({
        id,
        component: 'C061OverlayContact',
        field: 'title',
        value: title || '',
        limit: titleLimit,
        source: 'default',
    });
    usePreviewLimitCheck({
        id,
        component: 'C061OverlayContact',
        field: 'subtitle',
        value: subtitle || '',
        limit: subtitleLimit,
        source: 'default',
    });

    return (
        <CCOOverlay autoOpenKey='contactOverlayShown' breakpoints={breakpoints} isPreview={isPreview} linkText={linkText} withAutoOpen >
            <CCOPicture
                name={picture?.name}
                picture={picture}
                orientation={'portrait_ratio3x4'}
                width={'780'}
                height={'1040'}
                sxImage={{
                    borderRadius: '50%',
                    objectFit: 'cover'
                }}
                sxContainer={{
                    display: {
                        xs: 'none',
                        md: 'block',
                    },
                    position: 'absolute',
                    top: '80px',
                    left: '32px',
                    width: '256px',
                    height: '256px',
                    overflow: 'hiddenauto'
                }}/>
            <PreviewElementBoxDrawer propertyId={id}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 2,
                    overflow: 'hidden',
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        alignSelf: 'stretch',
                        gap: 4,
                        padding: '32px',
                        paddingLeft: {
                            xs: '32px',
                            md: '320px',
                        },
                        backgroundColor: 'primary.main',
                    }}>
                        <CCOHeadline metadataId={id} type={'h3'}
                                     propertyName='properties.title'
                                     headline={title}
                                     limit={titleLimit}
                                     color={'primary.contrastText'}/>
                        <CCOHeadline metadataId={id} type={'body1'}
                                     headline={subtitle}
                                     propertyName='properties.subtitle'
                                     limit={subtitleLimit}
                                     color={'primary.contrastText'}/>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        alignSelf: 'stretch',
                        flexGrow: 2,
                        gap: 4,
                        padding: {
                            xs: '24px 16px 24px 16px',
                            md: '32px 32px 32px 320px',
                            lg: '32px 32px 32px 320px',
                            xl: '32px 32px 48px 320px',
                        },
                        overflowY: 'auto',
                    }}>
                        <CCORichText metadataId={id} textAsTree={details} propertyName='properties.details' />
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            gap: 4,
                            overflowY: 'clip',
                        }}>
                            {targets.map(({id, selfUrl, teaserTitle}) =>
                                <CCOLinkButton
                                    key={id}
                                    id={id}
                                    url={selfUrl}
                                    backgroundColor='tertiary.main'
                                    color='tertiary.contrastText'
                                >
                                    {teaserTitle}
                                </CCOLinkButton>)}
                        </Box>
                    </Box>
                </Box>
            </PreviewElementBoxDrawer>
        </CCOOverlay>
    );
}

export default C061OverlayContact